export default "__VITE_ASSET__DuL8uVAy__"